"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formalities = exports.wrapComponent = exports.Indexed = exports.Select = exports.TextArea = exports.MultiCheckable = exports.Checkable = exports.Number = exports.Text = exports.Generic = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var React = __importStar(require("react"));
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
function BaseInput(props) {
    var value = props.value, setValue = props.setValue, display = props.display, convert = props.convert, updateOnBlur = props.updateOnBlur, rest = __rest(props, ["value", "setValue", "display", "convert", "updateOnBlur"]);
    var displayValue = display(value);
    function onChange(evt) {
        setValue(convert(evt.target.value));
    }
    if (updateOnBlur) {
        return (React.createElement("input", __assign({ defaultValue: displayValue, onBlur: onChange }, rest)));
    }
    else {
        return (React.createElement("input", __assign({ value: displayValue, onChange: onChange }, rest)));
    }
}
function BaseTextArea(props) {
    var value = props.value, setValue = props.setValue, display = props.display, convert = props.convert, updateOnBlur = props.updateOnBlur, rest = __rest(props, ["value", "setValue", "display", "convert", "updateOnBlur"]);
    var displayValue = display(props.value);
    function onChange(evt) {
        setValue(convert(evt.target.value));
    }
    if (updateOnBlur) {
        return (React.createElement("textarea", __assign({ defaultValue: displayValue, onBlur: onChange }, rest)));
    }
    else {
        return (React.createElement("textarea", __assign({ value: displayValue, onChange: onChange }, rest)));
    }
}
function Generic(props) {
    var controller = props.controller, prop = props.prop, convert = props.convert, display = props.display, rest = __rest(props, ["controller", "prop", "convert", "display"]);
    var snapshot = (prop !== 'this' ? controller.snapshot(prop) : controller.snapshot());
    return (React.createElement(BaseInput, __assign({ value: snapshot.value, setValue: snapshot.setValue, convert: convert, display: display }, rest)));
}
exports.Generic = Generic;
function Text(props) {
    var controller = props.controller, prop = props.prop, rest = __rest(props, ["controller", "prop"]);
    var snapshot = (prop !== 'this' ? controller.snapshot(prop) : controller.snapshot());
    return React.createElement(BaseInput, __assign({ value: snapshot.value, setValue: snapshot.setValue, convert: function (value) { return value !== '' ? value : undefined; }, display: function (value) { return value !== undefined && value !== null ? value : ''; } }, rest));
}
exports.Text = Text;
function Number(props) {
    var controller = props.controller, prop = props.prop, rest = __rest(props, ["controller", "prop"]);
    var snapshot = (prop !== 'this' ? controller.snapshot(prop) : controller.snapshot());
    return React.createElement(BaseInput, __assign({ value: snapshot.value, setValue: snapshot.setValue, convert: function (value) {
            var result = parseInt(value, 10);
            if (!isNaN(result)) {
                return result;
            }
            return undefined;
        }, display: function (value) {
            if (value !== undefined && value !== null) {
                return "" + value;
            }
            else {
                return '';
            }
        } }, rest));
}
exports.Number = Number;
function Checkable(props) {
    var controller = props.controller, prop = props.prop, checkedValue = props.checkedValue, uncheckedValue = props.uncheckedValue, rest = __rest(props, ["controller", "prop", "checkedValue", "uncheckedValue"]);
    var snapshot = (prop !== 'this' ? controller.snapshot(prop) : controller.snapshot());
    function onChange(evt) {
        if (evt.target.checked) {
            snapshot.setValue(checkedValue);
        }
        else {
            snapshot.setValue(uncheckedValue);
        }
    }
    return (React.createElement("input", __assign({ checked: fast_deep_equal_1.default(snapshot.value, checkedValue), onChange: onChange, value: checkedValue !== undefined && checkedValue !== null ? "" + checkedValue : '' }, rest)));
}
exports.Checkable = Checkable;
/**
 * indexOf implementation using the custom `equal` function
 * @param haystack
 * @param needle
 */
function myIndexOf(haystack, needle) {
    for (var i = 0; i < haystack.length; i++) {
        if (fast_deep_equal_1.default(needle, haystack[i])) {
            return i;
        }
    }
    return -1;
}
function MultiCheckable(props) {
    var controller = props.controller, prop = props.prop, checkedValue = props.checkedValue, uncheckedValue = props.uncheckedValue, rest = __rest(props, ["controller", "prop", "checkedValue", "uncheckedValue"]);
    var snapshot = (prop !== 'this' ? controller.snapshot(prop) : controller.snapshot());
    var value = snapshot.value;
    var checked = value ? myIndexOf(value, checkedValue) !== -1 : false;
    function onChange(evt) {
        var existing = value || [];
        var index = myIndexOf(existing, checkedValue);
        if (evt.target.checked) {
            if (index === -1) {
                var newValue = __spreadArray(__spreadArray([], existing), [checkedValue]);
                snapshot.setValue(newValue);
            }
        }
        else {
            if (index !== -1) {
                var newValue = __spreadArray([], existing);
                newValue.splice(index, 1);
                snapshot.setValue(newValue);
            }
        }
    }
    return (React.createElement("input", __assign({ checked: checked, onChange: onChange, value: checkedValue !== undefined && checkedValue !== null ? "" + checkedValue : '' }, rest)));
}
exports.MultiCheckable = MultiCheckable;
function TextArea(props) {
    var controller = props.controller, prop = props.prop, rest = __rest(props, ["controller", "prop"]);
    var snapshot = (prop !== 'this' ? controller.snapshot(prop) : controller.snapshot());
    return (React.createElement(BaseTextArea, __assign({ value: snapshot.value, setValue: snapshot.setValue, convert: function (value) { return value !== '' ? value : undefined; }, display: function (value) { return value !== undefined && value !== null ? value : ''; } }, rest)));
}
exports.TextArea = TextArea;
function isOptionTypeObject(o, props) {
    return props.display === undefined;
}
function isOptionTypeObjects(o, props) {
    return props.display === undefined;
}
function Select(props) {
    var controller = props.controller, prop = props.prop, options = props.options, display = props.display, rest = __rest(props, ["controller", "prop", "options", "display"]);
    var snapshot = (prop !== 'this' ? controller.snapshot(prop) : controller.snapshot());
    var value = snapshot.value;
    var selectedIndex = options ?
        isOptionTypeObjects(options, props)
            ? options.findIndex(function (o) { return fast_deep_equal_1.default(o.value, value); })
            : options.findIndex(function (o) { return fast_deep_equal_1.default(o, value); })
        : undefined;
    function onChange(evt) {
        var selectedIndex = evt.target.selectedIndex;
        /* Convert the selected index to an option index (in our this.props.options), in case the select's options aren't what we expected */
        var selectedItem = selectedIndex !== -1 ? evt.target.options.item(selectedIndex) : null;
        var selectedOptionIndex = selectedItem ? parseInt(selectedItem.value, 10) : -1;
        var newValue = undefined;
        if (selectedOptionIndex !== -1 && options) {
            var selectedOption = options[selectedOptionIndex];
            if (isOptionTypeObject(selectedOption, props)) {
                newValue = selectedOption.value;
            }
            else {
                newValue = selectedOption;
            }
        }
        snapshot.setValue(newValue);
    }
    return (React.createElement("select", __assign({ onChange: onChange, value: selectedIndex !== undefined ? selectedIndex : '' }, rest), options ?
        isOptionTypeObjects(options, props)
            ? options.map(function (item, index) { return (React.createElement("option", { key: index, value: index, label: item.label }, item.text || item.value)); })
            : options.map(function (item, index) { return (React.createElement("option", { key: index, value: index }, props.display(item))); })
        : null));
}
exports.Select = Select;
function Indexed(props) {
    var controller = props.controller, prop = props.prop, renderEach = props.renderEach, renderBefore = props.renderBefore, renderAfter = props.renderAfter, RenderEach = props.RenderEach, RenderBefore = props.RenderBefore, RenderAfter = props.RenderAfter;
    var actualController = prop !== 'this' ? controller.controller(prop) : controller;
    var snapshot = actualController.snapshot();
    var arrayValue = snapshot.value || [];
    var actions = {
        onPush: function (value) {
            snapshot.setValue(__spreadArray(__spreadArray([], arrayValue), [value]));
        },
        onInsert: function (index, value) {
            var newArrayValue = __spreadArray([], arrayValue);
            newArrayValue.splice(index, 0, value);
            snapshot.setValue(newArrayValue);
        },
        onRemove: function (index) {
            var newArrayValue = __spreadArray([], arrayValue);
            newArrayValue.splice(index, 1);
            snapshot.setValue(newArrayValue);
        },
    };
    return (React.createElement(React.Fragment, null,
        renderBefore ? renderBefore(actions) : null,
        RenderBefore ? React.createElement(RenderBefore, { actions: actions }) : null,
        renderEach ? arrayValue.map(function (v, i) {
            var indexController = actualController.controller(i);
            var cursor = {
                index: i,
                first: i === 0,
                last: i === arrayValue.length - 1,
            };
            return renderEach(indexController, cursor, actions);
        }) : null,
        RenderEach ? arrayValue.map(function (v, i) {
            var indexController = actualController.controller(i);
            var cursor = {
                index: i,
                first: i === 0,
                last: i === arrayValue.length - 1,
            };
            return React.createElement(RenderEach, { key: i, controller: indexController, cursor: cursor, actions: actions });
        }) : null,
        renderAfter ? renderAfter(actions) : null,
        RenderAfter ? React.createElement(RenderAfter, { actions: actions }) : null));
}
exports.Indexed = Indexed;
/**
 * Wrap a component function that takes a snapshot so that it instead accepts a controller and prop.
 * @param component A component function that takes a Snapshot
 */
function wrapComponent(component) {
    return function (props) {
        var controller = props.controller, prop = props.prop, rest = __rest(props
        // const snapshot = takeSnapshot(controller, prop) as Snapshot<V>
        , ["controller", "prop"]);
        // const snapshot = takeSnapshot(controller, prop) as Snapshot<V>
        var snapshot = (prop !== 'this' ? controller.snapshot(prop) : controller.snapshot());
        var componentProps = __assign(__assign({}, snapshot), rest);
        return component(componentProps);
    };
}
exports.wrapComponent = wrapComponent;
exports.Formalities = {
    Text: Text,
    Number: Number,
    Generic: Generic,
    Checkable: Checkable,
    MultiCheckable: MultiCheckable,
    TextArea: TextArea,
    Select: Select,
    Indexed: Indexed,
};
